<template>
<div class="component" v-if="isActive">

    <div class="modal is-active">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Benutzer hinzufügen</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body">

                <ul class="menu-list" v-if="companyUser!=null&&companyUser.length>0">
                    <li v-for="user in companyUser" @click="addUser(user.id)"><a>{{user.name}}</a></li>

                </ul>
                <div v-else>Keine weiteren Nutzer</div>

            </section>
            <footer class="modal-card-foot">
       
            </footer>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'NewProjectModal',
    props: ["isActive", "projectId"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            companyUser: []
        }
    },
    methods: {
        closeModal() {
            this.$emit("close")
        },
        getAllCompanyUser() {

            let postData = {
                "projectId": this.projectId,
            }
            this.callApi("/project/possibleMembers", "post", postData).then(function (response) {
                this.companyUser = response.data.user
            }.bind(this))
        },
        addUser(userId) {
            let postData = {
                "projectId": this.projectId,
                "userId": userId
            }
            this.callApi("/project/addUser", "post", postData).then(function (response) {
                this.getAllCompanyUser();
                this.refresh();
            }.bind(this))
        },
        refresh(){
this.$emit("refresh")
        },
    },
    computed: {},
    watch: {
        isActive: function (val) {
            this.getAllCompanyUser();
            console.log("isActive changed to " + val)
        }
    }
}
</script>

<style scoped>

</style>
